export function transformUserData(response) {
    return {
        ...response,
        subscriptions: response?.subscriptions?.edges?.map((edge) => edge?.node),
    };
}
export function transformFolder(folder) {
    return folder?.guideId?.slice(1) || '';
}
